import { CircularProgress } from '@mui/material';
import BackendService from 'BackendService';
import { CommonLoggedInDataContext, useCommonLoggedInData } from 'CommonLoggedInData';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Article } from '../../../models/Article';
import ArticleApprovalRouteWrapper from '../ArticleApprovalRouteWrapper';

export interface LookupArticleProps {
  type: 'ArticleApproval';
}

export default function LookupArticle(props: LookupArticleProps) {
  const { id } = useParams();
  const { type } = props;
  const [article, setArticle] = useState<Article | null>(null);

  const loggedInData = useCommonLoggedInData();

  useEffect(() => {
    const fetchArticle = () => {
      new BackendService()
        .getArticle(id!)
        .then((article) => {
          if (article) {
            setArticle(article);
          }
        })
        .catch((error) => {
          console.error('Error fetching fund opportunity:', error);
        });
    };

    fetchArticle();
  }, [id, type]);

  if (!article) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }

  return (
    <CommonLoggedInDataContext.Provider value={loggedInData}>
      {type === 'ArticleApproval' ? <ArticleApprovalRouteWrapper article={article!} /> : null}
    </CommonLoggedInDataContext.Provider>
  );
}
